import { ApplicationElement, html } from '../application_element/element.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import '../icon/element.js';
import style from './style.lit.css';

/**
 * Image placeholder for the picture that will fallback to the icon
 *
 * @prop icon - Icon (default: image) (optional)
 * @prop picture - Url of the picture (optional)
 * @prop alt - Alt text for picture (optional)
 * @prop rounded - Used just for CSS styling (optional)
 *
 * @cssprop [--element-size=40px] Element size.
 * @cssprop [--font-size-primary=26px] Icon size.
 * @cssprop [--background-primary=var(--gray-300)] Background color.
 */

export default class ImgPlaceholder extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    icon: { type: String },
    picture: { type: String },
    alt: { type: String },
    rounded: { type: Boolean, reflect: true },
  };

  constructor() {
    super();
    this.icon = 'image';
  }

  /** @internal */
  renderIcon() {
    return html` <ef-icon name="${this.icon}"></ef-icon> `;
  }

  /** @internal */
  renderPicture() {
    return html` <img src="${this.picture}" alt=${ifDefined(this.alt)} /> `;
  }

  render() {
    return html` ${this.picture ? this.renderPicture() : this.renderIcon()} `;
  }
}

customElements.get('ef-img-placeholder') ||
  customElements.define('ef-img-placeholder', ImgPlaceholder);
